<template>
	<div class="circles-comment" v-if="value">
		<div class="publish-box clearfix textarea-box">
			<div class="publish-avatar">
				<img src="~@/assets/img/index/dxfy-left.png" />
			</div>
			<div class="publish-right">
				<!-- <VueEmoji @input="editInput" :value="myText" /> -->
				<textarea class="publish-textarea" v-model="myText"></textarea>
				<div class="clearfix textarea-tools-box">
					<button class="fr btn-primary btn-sm" @click="comment">发布</button>
					<!-- <div class="publish-icon">
						<img src="~@/assets/img/culturalCircles/emjoy.png" />表情
					</div>
					<div class="publish-icon">
						<img src="~@/assets/img/culturalCircles/tupian@2x.png" />图片
					</div> -->
				</div>
			</div>
		</div>
		<ul class="comment-list">
			<li v-for="item in curData_" :key="item.id">
				<div class="publish-box clearfix">
					<div class="publish-avatar" v-if="item.user">
						<img :src="item.user.userExt | imgUrl('userImgUrl')" />
					</div>
					<div class="publish-right">
						<div class="comment-text">
							<span>{{item.user && item.user.username}}</span>
							<div class="comment-html" v-html="item.commentText"></div>
						</div>
						<div class="publish-time">{{item.releaseTimestamp | time}}</div>
					</div>
				</div>
			</li>
		</ul>
		<div class="comment-more" v-if="!busy_">
			<button class="btn-default btn-sm" @click="changeType(0, curPage + 1)">查看更多</button>
		</div>
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	// import VueEmoji from 'emoji-vue'
	export default {
		mixins: [ listMixin ],
		components: {
			// VueEmoji
		},
		data() {
			return {
				pageSize: 5,
				isAuto: false,
				myText: '',
				contentId: '',
				routeName: 'comment',
				isConcat: true
			}
		},
		props: {
			value: {
				type: Boolean,
				default: false
			},
			cId: {
				type: [String, Number],
				default: ''
			}
		},
		watch: {
			value(val) {
				if(val && this.cId){
					this.contentId = this.cId;
					this.init(true);
				}
			}
		},
		methods: {
			editInput(e) {
				console.log(e);
				this.myText = e.data;
			},
			async comment() {
				if(!this.myText){
					return this.$toast('评论内容不能为空');
				}
				let params = {
					contentId: this.cId,
					commentText: this.myText
				}
				let res = await this.$http('comment', params);
				if(res.code === 1) this.myText = '';
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	
	.circles-comment{
		margin: 0 -30px;
		background-color: #F6FBFF;
		position: relative;
		border-top:1px solid rgba(222,222,222,1);
		&::before{
			content: '';
			z-index: 2;
			@include abs(-10px, 56px);
			width:18px;
			height:18px;
			background:rgba(246,250,255,1);
			border-left:1px solid rgba(222,222,222,1);
			border-top:1px solid rgba(222,222,222,1);
			transform: rotate(45deg);
		}
		.comment-list{
			padding: 24px 30px 36px;
			& > li{
				& + li{
					margin-top: 30px;
				}
			}
		}
		.comment-more{
			border-top:1px solid rgba(222,222,222,1);
			padding: 8px 0;
			.btn-default{
				width:160px;
				background-color: #fff;
			}
		}
		.publish-box{
			&.textarea-box{
				padding: 25px 30px 0;
			}
			.publish-avatar{
				float: left;
				width: 50px;
				img{
					width:50px;
					height:50px;
					border-radius:50%;
				}
			}
			.publish-right{
				width: 534px;
				float: right;
				padding-left: 10px;
				.comment-text{
					font-size:14px;
					font-weight:400;
					color:rgba(72,72,72,1);
					line-height:24px;
					span{
						color: #537ABC;
						margin-right: 8px;
					}
					.comment-html{
						display: inline;
					}
				}
				.publish-time{
					font-size:14px;
					font-weight:400;
					color:rgba(185,185,185,1);
					line-height:18px;
					margin-top: 10px;
				}
			}
		}
	}
</style>
